import React, { useEffect } from "react";
import { Button, IconButton, Stack } from "@mui/material";
import Logo from "../../../components/common/layout/header/Logo";
import UserSetting from "../../../components/common/layout/header/UserSetting";
import { LuBuilding2, LuHome, LuRefreshCcw, LuStore } from "react-icons/lu";
import { useDispatch, useSelector } from "react-redux";
import SelectApiInput from "../../../components/common/input/SelectApiInput";
import { updateCurrentStore } from "../../../redux/reducers/kitchen.reducer";
import { asyncSearchList } from "../../../utils/httpRequests";
import { useAlertContext } from "../../../contexts/alert/AlertProvider";
import { useBackdropContext } from "../../../contexts/backdrop/BackdropProvider";
import { useKitchenContext } from "../KitchenPage";

interface IHeader {
  height: string;
}
function Header({ height }: IHeader) {
  const token = useSelector((state: any) => state.auth.token);
  const app = useSelector((state: any) => state.app.data);
  const { currentStore } = useSelector((state: any) => state.kitchen);
  const { showAlert } = useAlertContext();
  const { setOpenBackdrop } = useBackdropContext();
  const { setHds, setLoad } = useKitchenContext();
  const dispatch = useDispatch();

  const getHds = async () => {
    setOpenBackdrop?.(true);
    const resp = await asyncSearchList({
      apiCode: "pbl_nh",
      token,
      idApp: app?._id,
      condition: {
        page: 1,
        limit: 999999,
        q: { ma_kho: currentStore?.ma_kho, trang_thai: "1" },
      },
    });
    if (resp?.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error ||
          resp?.data?.message ||
          "Lỗi khi tải thông tin đơn hàng",
      });
    }
    setHds(resp?.data || []);
    setOpenBackdrop?.(false);
  };

  const handleStoreChange = (store: any) => {
    dispatch(updateCurrentStore(store));
  };

  useEffect(() => {
    if (!currentStore) {
      const displayStore = document.getElementById("display-store");
      displayStore?.click();
    } else {
      getHds();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStore]);

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ height, px: 2, backgroundColor: "background.paper" }}
    >
      <Logo />
      <Stack direction="row" alignItems="center" gap={1}>
        <IconButton
          onClick={() => setLoad((prev) => prev + 1)}
          sx={{
            borderRadius: "10px",
            color: "common.white",
            backgroundColor: "secondary.main",
            "&:hover": {
              backgroundColor: "secondary.main",
            },
          }}
        >
          <LuRefreshCcw size={20} />
        </IconButton>
        <SelectApiInput
          forceOpenSelect={!currentStore}
          selectTitle="Chọn chi nhánh"
          wrapperSx={{ width: "120px", height: "42px" }}
          apiCode="dmkho"
          searchFields={["ma_kho", "ten_kho"]}
          getOptionLabel={(option) => option.ten_kho}
          checkEqual={(value, option) => value?.ma_kho === option?.ma_kho}
          value={currentStore}
          onChange={handleStoreChange}
          renderDisplay={({ value, onClick }) => {
            return (
              <Button
                id="display-store"
                size="small"
                variant="contained"
                onClick={onClick}
                sx={{
                  backgroundColor: "background.default",
                  color: "text.primary",
                  textTransform: "none",
                  fontWeight: 400,
                  boxShadow: "none",
                  height: "34px",
                  "&:hover": {
                    boxShadow: "none",
                  },
                }}
                startIcon={<LuStore size={16} />}
              >
                {value?.ten_kho || "Chọn chi nhánh"}
              </Button>
            );
          }}
        />
        <UserSetting
          options={[
            {
              path: "/",
              text: "Trang chủ",
              Icon: LuHome,
            },
            {
              path: "/app",
              text: "Danh sách công ty",
              Icon: LuBuilding2,
            },
          ]}
        />
      </Stack>
    </Stack>
  );
}

export default Header;
